<template>
    <div>
        <input type="file" @change="uploadCsv" class="d-none">
        <div class="d-flex flex-column align-items-center">
            {{ filename }}
            <span v-if="error" class="text-danger">{{ error }}</span>
            <button class="ds-btn mt-3" type="button" @click="pickCsv" :disabled="isProcessing">
                Izvēlēties failu
            </button>
            <small v-if="!filename" class="text-muted small mt-2">Izvēlies failu .csv formātā</small>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        name: 'csv-upload',
        props: {
            file: {
                type: String,
                required: false,
                default: '',
            },
        },
        data() {
            return {
                filename: this.file,
                isProcessing: false,
                error: '',
            }
        },
        methods: {
            pickCsv() {
                this.$el.querySelector('input').click();
            },
            async uploadCsv(e) {
                this.error = '';
                const [csv] = e.target.files;

                if (!csv) {
                    return;
                }

                // if (csv.type !== 'text/csv' || csv.type !== 'text/plain') {
                //     this.error = 'Pievieno failu CSV formātā!';
                //     return;
                // }

                this.isProcessing = true;

                const formData = new FormData;
                formData.append('csv', csv);

                const {data: {filename, users, success}} = await axios.post('/api/users/parse-csv', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                });

                if (!success) {
                    return alert('Kaut kas nogāja greizi.');
                }

                this.filename = filename;
                this.$emit('uploaded', {filename, users});

                this.isProcessing = false;
                e.target.value = '';
            },
        }
    }
</script>